import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { BRAND, waLink } from "../config";
import { subscribeNewsletter } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const r = await subscribeNewsletter({ first_name: name, email });
      toast.success(`Merci ! Profitez de -10% avec le code ${r.code}`);
      setEmail(""); setName("");
    } catch { toast.error("Une erreur est survenue"); }
  };

  return (
    <footer className="bg-noir text-white/80" data-testid="site-footer">
      <div className="border-b border-white/10 py-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="font-serif-el italic text-dore text-lg">Rejoignez la communauté d'Esther</p>
          <h3 className="font-display text-2xl md:text-4xl text-white mt-2 mb-4">Recevez nos exclusivités</h3>
          <p className="text-white/60 text-sm mb-6">Nouveautés en avant-première, promotions exclusives et invitations aux ventes privées.</p>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="newsletter-form">
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Prénom"
              className="flex-1 bg-white/5 border border-white/15 px-4 py-3 text-sm text-white placeholder:text-white/40 focus:border-dore outline-none" data-testid="newsletter-name" />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre email"
              className="flex-1 bg-white/5 border border-white/15 px-4 py-3 text-sm text-white placeholder:text-white/40 focus:border-dore outline-none" data-testid="newsletter-email" />
            <button className="bg-dore text-noir px-6 py-3 text-xs uppercase tracking-widest font-semibold hover:bg-dore/90 transition-colors" data-testid="newsletter-submit">S'inscrire</button>
          </form>
          <p className="text-dore/80 text-xs mt-3">-10% offert à l'inscription</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <h4 className="font-display text-xl text-white mb-3">La Boutique <span className="text-dore">d'Esther</span></h4>
          <p className="text-sm text-white/50 leading-relaxed">Mode & accessoires féminins en Guadeloupe. L'élégance qui vous ressemble.</p>
          <div className="flex gap-4 mt-5">
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="hover:text-dore transition-colors" aria-label="Instagram"><Instagram size={20} /></a>
            <a href={BRAND.facebook} target="_blank" rel="noreferrer" className="hover:text-dore transition-colors" aria-label="Facebook"><Facebook size={20} /></a>
            <a href={`mailto:${BRAND.email}`} className="hover:text-dore transition-colors" aria-label="Email"><Mail size={20} /></a>
          </div>
        </div>

        <div>
          <h5 className="text-dore uppercase text-xs tracking-widest mb-4">Navigation</h5>
          <ul className="space-y-2 text-sm">
            <li><Link to="/boutique" className="hover:text-dore transition-colors">Boutique</Link></li>
            <li><Link to="/nouveautes" className="hover:text-dore transition-colors">Nouveautés</Link></li>
            <li><Link to="/promotions" className="hover:text-dore transition-colors">Promotions</Link></li>
            <li><Link to="/ventes-privees" className="hover:text-dore transition-colors">Ventes Privées</Link></li>
          </ul>
        </div>

        <div>
          <h5 className="text-dore uppercase text-xs tracking-widest mb-4">Informations</h5>
          <ul className="space-y-2 text-sm">
            <li><Link to="/livraison-retours" className="hover:text-dore transition-colors">Livraison & Retours</Link></li>
            <li><Link to="/guide-des-tailles" className="hover:text-dore transition-colors">Guide des tailles</Link></li>
            <li><Link to="/cgv" className="hover:text-dore transition-colors">CGV</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-dore transition-colors">Mentions légales</Link></li>
            <li><Link to="/faq" className="hover:text-dore transition-colors">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h5 className="text-dore uppercase text-xs tracking-widest mb-4">Contact</h5>
          <ul className="space-y-3 text-sm">
            <li><a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-dore transition-colors"><Phone size={15} /> {BRAND.whatsappDisplay}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-dore transition-colors"><Mail size={15} /> Email</a></li>
            <li><a href={BRAND.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-dore transition-colors"><Instagram size={15} /> {BRAND.instagramHandle}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© 2024 La Boutique d'Esther — Tous droits réservés — Guadeloupe 971</p>
          <div className="flex items-center gap-3">
            <Link to="/confidentialite" className="hover:text-dore transition-colors">Confidentialité</Link>
            <Link to="/cookies" className="hover:text-dore transition-colors">Cookies</Link>
            <span className="text-white/50 font-medium tracking-wide">CB · Visa · Mastercard · PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
